import React from 'react';

import FormGroup from '~/commons/components/FormGroup.jsx';

const FieldsCompGen = ({
  fileUploadUrl,
}) => (
  <div className="pt-3">
    <div className="row">
    <div className="col-auto">
      <div className="col-auto">
        <FormGroup name="dates" as="dayrangepicker" />
      </div>
      <div className="col-auto">
        <FormGroup name="awardsPeriod" as="dayrangepicker" label="Awards Period" required/>
      </div>
      </div>
      <div className="col">
        <div className="form-row">
          <div className="col">
            <FormGroup name="refCode" label="Reference Code" required />
          </div>
          <div className="col">
            <FormGroup
              name="duration"
              type="number"
              label="Duration (in minutes)"
              min={0}
              required
            />
          </div>
        </div>
        <FormGroup name="title" required />

        <h6 className="small border-bottom text-muted py-1 pt-4 mb-3">
          COMPETITION DETAILS
        </h6>
        <FormGroup
          name="coverImg"
          as="coverImg"
          label="Cover Image (suggested dimension: 1200 x 675px)"
          api={fileUploadUrl}
        />
        <FormGroup
          name="description"
          as="summernote"
          fileUploadUrl={fileUploadUrl}
        />

        <h6 className="small border-bottom text-muted py-1 pt-4 mb-3">
          COMPETITION MESSAGES
        </h6>
        <FormGroup name="beforeStartMsg" />
        <FormGroup name="completedMsg" />

        <h6 className="small border-bottom text-muted py-1 pt-4 mb-3">
          MESSAGES BEFORE LOGIN
        </h6>
        <FormGroup
          name="beforeOpenMsg"
          as="summernote"
          fileUploadUrl={fileUploadUrl}
        />
        <FormGroup
          name="openedMsg"
          as="summernote"
          fileUploadUrl={fileUploadUrl}
        />
        <FormGroup
          name="closedMsg"
          as="summernote"
          fileUploadUrl={fileUploadUrl}
        />
      </div>
    </div>
  </div>
);

export default FieldsCompGen;
